import styled from 'styled-components';
import colors from 'styles/colors';

export const Container = styled.div`
  font-size: 12px;
  font-weight: bold;
  margin: 8px 0 4px;
  text-transform: uppercase;
`;

export const Status = styled.span`
  color: ${colors.grey};
  margin-right: 20px;
`;
